import { InjectionToken } from "@angular/core";
import { WalletLiveViewPort } from "./wallet-live-view.port";

export const WALLET_LIVE_VIEW_PORT =
  new InjectionToken<WalletLiveViewPort>("WALLET_LIVE_VIEW_PORT");
